import React, { useState, useEffect } from 'react';
import { Box, BoxProps } from '@mui/material';
import {
  getDisplayImageSrc,
  getProxiedImageUrl,
  isExternalImageUrl,
  PLACEHOLDER_PRODUCT_IMAGE,
} from '../utils/productImages';

interface ProductImageProps extends BoxProps {
  src?: string | null;
  alt?: string;
}

const ProductImage: React.FC<ProductImageProps> = ({ src, alt = '', sx, ...props }) => {
  const [imgSrc, setImgSrc] = useState(() => getDisplayImageSrc(src));
  const [hasErrored, setHasErrored] = useState(false);

  useEffect(() => {
    setImgSrc(getDisplayImageSrc(src));
    setHasErrored(false);
  }, [src]);

  const handleError = () => {
    if (src && isExternalImageUrl(src) && imgSrc === src) {
      setImgSrc(getProxiedImageUrl(src));
      return;
    }

    if (!hasErrored) {
      setHasErrored(true);
      setImgSrc(PLACEHOLDER_PRODUCT_IMAGE);
    }
  };

  return (
    <Box
      component="img"
      src={imgSrc}
      alt={alt}
      onError={handleError}
      referrerPolicy="no-referrer"
      sx={sx}
      {...props}
    />
  );
};

export default ProductImage;
